import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import {
  ApolloInjection,
  invoices as InvoicesQueryData,
  QueryResult,
} from "@zapier/payment/esm/types";

import { useCurrentAccountId } from "../useCurrentAccountId";

export const invoicesQuery = gql`
  query invoices($accountId: Int!) {
    account(id: $accountId) {
      id
      invoices {
        id
        createdAt
        hasPendingPayment
      }
    }
  }
`;

const usePendingPayment = (props?: ApolloInjection) => {
  const useQuery = props?.useQuery ?? defaultUseQuery;
  const { accountId } = useCurrentAccountId({ useQuery });
  const { data, loading }: QueryResult<InvoicesQueryData> = useQuery(
    invoicesQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  const pendingInvoice = data?.account?.invoices?.find(
    invoice => invoice.hasPendingPayment
  );

  return {
    pendingInvoice,
    isLoading: loading,
  };
};

export default usePendingPayment;
